import { useState, useEffect, useMemo } from 'react';
import api from '../api';
import logger from './logger';

// Loads who favorited/shortlisted the current user.
// Returns username Sets so pages can compute mutual = mySet.has(u) && theirSet.has(u).
const nameOf = (u) => u?.username || u?.viewerProfile?.username || u?.userProfile?.username;

export default function useMutualInterests(username) {
  const [theirFav, setTheirFav] = useState(() => new Set());
  const [theirShort, setTheirShort] = useState(() => new Set());

  useEffect(() => {
    if (!username) return undefined;
    let alive = true;
    Promise.all([
      api.get(`/their-favorites/${encodeURIComponent(username)}`).catch(() => ({ data: {} })),
      api.get(`/their-shortlists/${encodeURIComponent(username)}`).catch(() => ({ data: {} })),
    ]).then(([favRes, shortRes]) => {
      if (!alive) return;
      setTheirFav(new Set((favRes.data?.users || []).map(nameOf).filter(Boolean)));
      setTheirShort(new Set((shortRes.data?.users || []).map(nameOf).filter(Boolean)));
    }).catch((err) => logger.error('Mutual interests load failed:', err));
    return () => { alive = false; };
  }, [username]);

  return useMemo(() => ({ theirFav, theirShort }), [theirFav, theirShort]);
}
